<template>
  <div class="my_form">
    <el-form :model="form" ref="ruleForm" inline>
      <el-row>
        <el-col :lg="6" :md="24">
          <el-form-item label="部门:" prop="deptId" v-if="getUserInfo.deptName === '办公室'">
            <el-select filterable v-model="form.deptId" placeholder="请选择部门" clearable>
              <el-option
                v-for="item in deptList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="6" :md="24">
          <el-form-item label="姓名:" prop="userId" v-if="getUserInfo.deptName === '办公室'">
            <el-select filterable v-model="form.userId" placeholder="请选择姓名" clearable>
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :lg="7" :md="24">
          <el-form-item label="时间:" prop="date">
            <el-date-picker
              :clearable="false"
              v-model="form.date"
              type="month"
              format="yyyy-MM"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :lg="5" :md="24" class="action" style="margin-bottom: 20px">
          <el-button size="small" type="primary" @click="submitForm" plain>查询</el-button>          
          <download-excel
            style="margin-left:20px"
            class="export-excel-wrapper"
            :data="json_data"
            :fields="json_fields"
            type="xls"
            worksheet="My Worksheet"
            name="月度考勤统计"
          >
            <el-button size="small" >导出</el-button>
          </download-excel>
        </el-col>
      </el-row>
    </el-form>
    <div class="record">
      <div class="record-box" v-for="item in list" :key="item.name">
        <div class="title">{{ item.title }}</div>
        <div class="count">{{ item.count }}</div>
      </div>
    </div>
    <PTable :columns="columns" :loadData="loadData" ref="table">
      <template #sn="{ $index }">
        {{ $index + 1 }}
      </template>
      <template #rule>
        {{ "8:00-17:00" }}
      </template>
      <template v-for="(item, index) in propArr" :slot="`${item}dutyTime`" slot-scope="scope">
        <div :class="className(scope.row.oaEmployeeDailyAttendList[index].attendType)">
          {{ scope.row.oaEmployeeDailyAttendList[index].realDutyTime }}
        </div>
      </template>
      <template v-for="(item, index) in propArr" :slot="`${item}offTime`" slot-scope="scope">
        <div :class="className(scope.row.oaEmployeeDailyAttendList[index].attendType)">
          {{ scope.row.oaEmployeeDailyAttendList[index].realOffTime }}
        </div>
      </template>
      <template #action="record">
        <a
          class="success"
          href="javascript:;"
          @click="handleOpenDetail(record.row)"
          >编辑</a
        >
        <a class="delete" href="javascript:;" @click="handleDelete(record.row)"
          >删除</a
        >
      </template>
    </PTable>
  </div>
</template>

<script>
import PTable from "@/components/PTable";
import { Attendance } from "@/api/attendance";
import dayjs from "dayjs";
export default {
  data() {
    return {
      // 导出
      json_fields: {},
      json_data: [],
      form: {
        deptId: "",
        userId: "",
        date: new Date(),
      },
      list: [
        {
          title: "需考勤人数",
          count: 0,
        },
        {
          title: "正常(人数)",
          count: 0,
        },
        {
          title: "迟到(人数)",
          count: 0,
        },
        {
          title: "早退(人数)",
          count: 0,
        },
        {
          title: "上班缺卡(人数)",
          count: 0,
        },
        {
          title: "下班缺卡(人数)",
          count: 0,
        },
        {
          title: "缺勤(人数)",
          count: 0,
        },
        {
          title: "请假(人数)",
          count: 0,
        },
      ],
      columns: [
        {
          label: "序号",
          scopedSlots: "sn",
          width: 80,
          fixed: "left",
        },
        {
          label: "基本信息",
          width: 200,
          fixed: "left",
          children: [
            {
              label: "姓名",
              prop: "name",
              width: 100,
            },
            {
              label: "部门",
              prop: "deptName",
              width: 130,
            },
          ],
        },
        {
          label: "出勤统计",
          width: 160,
          fixed: "left",
          children: [
            {
              label: "应该出勤天数",
              prop: "attendCount",
              width: 80,
            },
            {
              label: "实际出勤天数",
              prop: "realAttendCount",
              width: 80,
            },
          ],
        },
        {
          label: "异常统计",
          width: 330,
          fixed: "left",
          children: [
            {
              label: "迟到次数",
              prop: "lateCount",
              width: 60,
            },
            {
              label: "早退次数",
              prop: "earlyLeaveCount",
              width: 60,
            },
            {
              label: "缺勤天数",
              prop: "absenceCount",
              width: 60,
            },
            {
              label: "缺卡次数",
              prop: "lackCardCount",
              width: 60,
            },
            {
              label: "请假天数",
              prop: "askLeaveCount",
              width: 60,
            },
          ],
        },
        {
          label: "考勤明细",
          children: [],
        },
      ],
      loadData: (pageParam) => {
        const date = dayjs(this.form.date).format("YYYY-MM");
        const OaEmployeeDailyAttendControllerQueryList = {
          monthDate:date,
          pageParam,
          userId: this.getUserInfo.deptName === '办公室' ? this.form.userId :  this.getUserInfo.userId,
          deptId: this.form.deptId,
        };
        const num = dayjs(date).daysInMonth();
        const arr = [];
        const week = [
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六",
        ];
        this.propArr = [];
        this.json_fields = {
            '姓名': 'name', //常规字段
            '部门名称': 'deptName', //支持嵌套属性
            '应该出勤天数':'attendCount',
            '实际出勤天数':'realAttendCount',
            '迟到次数':'lateCount',
            '早退次数':'earlyLeaveCount',
            '缺勤天数':'absenceCount',
            '缺卡次数':'lackCardCount',
            '请假天数':'askLeaveCount'
        }
        for (let index = 0; index < num; index++) {
          const day = dayjs(dayjs(date+'-1').add(index, "day")).format(
            "YYYY-MM-DD"
          );
          this.propArr.push(day);
          this.json_fields[`${day}${week[dayjs(day).day()]}(上班)`] = day + 'dutyTime'
          this.json_fields[`${day}${week[dayjs(day).day()]}(下班)`] = day + 'offTime'
          arr.push(
            {
              label: `${day}${week[dayjs(day).day()]}`,
              prop: day + "dutyTime",
              scopedSlots: day + 'dutyTime',
              width: 90,
            },
            {
              label: "",
              prop: day + "offTime",
              scopedSlots: day + 'offTime',
              width: 90,
            }
          );
        }
        this.columns[4].children = arr
        return Attendance.getMonthAttendanceList(
          this,
          OaEmployeeDailyAttendControllerQueryList
        ).then((res) => {
          res.data.dataList.forEach((item) => {
            item.oaEmployeeDailyAttendList.forEach((data) => {
              data.realOffTime = data.realOffTime && data.realOffTime.split(' ')[1]
              data.realDutyTime =data.realDutyTime &&  data.realDutyTime.split(' ')[1]
              item[data.date + "dutyTime"] = data.realDutyTime || ''
              item[data.date + "offTime"] = data.realOffTime || ''
            });
          });
          this.json_data = res.data.dataList
          return res;
        });
      },
      userList: [],
      deptList: [],
      propArr:[]
    };
  },
  components: {
    PTable,
  },
  created() {
    this.getList();
    this.initData();
  },
  methods: {
    getList() {
      Attendance.gitDict(this, { dictId: "1440944417170001920" }).then(
        (res) => {
          this.userList = res.data;
        }
      );
      Attendance.gitDict(this, { dictId: "1630757245237071872" }).then(
        (res) => {
          this.deptList = res.data;
        }
      );
    },
    initData() {
      const data = {
        monthDate: dayjs(this.form.date).format("YYYY-MM"),
        userId: this.form.userId,
        deptId: this.form.deptId,
      };
      Attendance.getMonthAttendanceNumber(this, data).then((res) => {
        this.list[0].count = res.data.needAttendNum;
        this.list[1].count = res.data.normalNum;
        this.list[2].count = res.data.lateNum;
        this.list[3].count = res.data.earlyNum;
        this.list[4].count = res.data.dutyNum;
        this.list[5].count = res.data.offNum;
        this.list[6].count = res.data.absenceNum;
        this.list[7].count = res.data.askNum;
      });
    },
    submitForm(flag = true) {
      this.initData()
      if (this.$refs.table) this.$refs.table.refresh(flag);
    },
    className(className) {
      let name = className === 'ABNORMAL' ? 'red' :''
      return name
     }
  },
};
</script>

<style lang="scss" scoped>
.action{
  display: flex;
}
.record {
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  margin: 20px 0 40px;

  .record-box {
    border: 1px solid #dedede;

    .title {
      background-color: #f1efef;
      padding: 5px 20px;
    }

    .count {
      text-align: center;
      padding: 15px 0;
    }
  }
}

.red{
    // background-color: rgb(246, 134, 134);
    color:red;
  }
</style>
